<template>
  <b-modal
    id="modal-filter"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    centered
    title="過瀘"
    headerClass="pr-3 py-2 border-bottom bgWhite"
    footerClass="px-3 py-2 border-top bgWhite"
    hide-footer
    no-close-on-backdrop
    size="sm"
  >
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12" v-if="!is_user_page">
            <b-form-group
              label="申請人："
              label-for="filter_user_id"
              label-cols-md="3"
            >
            <v-select
                id="filter_user_id"
                v-model="update.filter_user_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="userOptions.filter(item => item.user_type_id != 2)"
                label="name_cn"
                :reduce="(option) => option.id"
                placeholder="選擇申請預支人"
                :filter="userSearch"
              >
                <template #option="{ roles, name_cn }">
                  <template v-if="roles && roles[0]">
                    [{{ roles[0].name }}] {{ name_cn }}
                  </template>
                  <template v-else>
                    {{ name_cn }}
                  </template>
                </template>
                <template #selected-option="{ roles, name_cn }">
                  <template v-if="roles && roles[0]">
                    [{{ roles[0].name }}] {{ name_cn }}
                  </template>
                  <template v-else>
                    {{ name_cn }}
                  </template>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <!-- <b-col cols="12">
            <b-form-group
              label="項目："
              label-for="filter_project_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_project_id"
                v-model="update.filter_project_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="projectOptions"
                label="project_name"
                :reduce="(option) => option.id"
                :filter="projectSearch"
                placeholder="選擇項目"
              >
                <template #option="{ project_number, project_name }">
                  [{{ project_number }}] {{ project_name }}
                </template>
                <template #selected-option="{ project_number, project_name }">
                  [{{ project_number }}] {{ project_name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col> -->

          <b-col cols="12">
            <b-form-group
              label="預支狀態："
              label-for="filter_prepayment_status_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_prepayment_status_id"
                v-model="update.filter_prepayment_status_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="prepaymentStatusOptions"
                label="name"
                :reduce="(option) => option.id"
                :filter="prepaymentStatusSearch"
                placeholder="選擇預支狀態"
              ></v-select>
            </b-form-group>
          </b-col>
          <!-- <b-col cols="12">
            <b-form-group
              label="批准狀態："
              label-for="filter_approval_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_approval_id"
                v-model="update.filter_approval_id"
                :clearable="true"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="approvalStatusOptions"
                label="name"
                :reduce="(option) => option.id"
                placeholder="選擇批准狀態"
              ></v-select>
            </b-form-group>
          </b-col> -->
         
         
        </b-row>
        <div class="d-flex mt-2 justify-content-end">
          <!-- type="reset" -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="update = {}"
            class="mr-1"
          >
            重置
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-danger"
            class="mr-1"
            @click="hide"
          >
            取消
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
          >
            <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
            提交
          </b-button>
        </div>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BCardBody,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCardBody,
    BCard,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-filter");
    },
    userSearch(options, search){
      var returnOptions = options.filter(item => {
        return item.name_cn.toLowerCase().includes(search.toLowerCase()) || item.roles[0].name.toLowerCase().includes(search.toLowerCase())
      })
      return returnOptions
    },
    projectSearch(options, search){
      var returnOptions = options.filter(item => {
        return item.project_number.toLowerCase().includes(search.toLowerCase()) || item.project_name.toLowerCase().includes(search.toLowerCase())
      })
        return returnOptions
    },
    prepaymentStatusSearch(options, search) {
      var returnOptions = options.filter(item => {
        return item.name.toLowerCase().includes(search.toLowerCase())
      })
      return returnOptions
    },
    onSubmit() {
      this.$emit("update:filter_project_id", this.update.filter_project_id);
      this.$emit("update:filter_user_id", this.update.filter_user_id);
      this.$emit("update:filter_approval_id", this.update.filter_approval_id);
      this.$emit(
        "update:filter_prepayment_status_id",
        this.update.filter_prepayment_status_id
      );
      this.hide();
    },
  },
  props: {
    projectOptions: {
      type: Array,
      required: true,
    },
    userOptions: {
      type: Array,
      required: true,
    },
    prepaymentStatusOptions: {
      type: Array,
      required: true,
    },
    is_user_page: {
    },
    filter_project_id: {},
    filter_user_id: {},
    filter_approval_id: {},
    filter_prepayment_status_id: {},
  },
  data() {
    return {
      loading: false,
      user_type_id: JSON.parse(localStorage.getItem("userData")).user_type_id,
      approvalStatusOptions: [{id:1, name:"已批准"}, {id:0, name:"未批准"}],
      update: {
        filter_project_id: null,
        filter_user_id: null,
        filter_approval_id:null,
        filter_prepayment_status_id: null,
      },
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
